<template>
  <div>
    <v-btn fab dark fixed bottom right :color="activeFab.color" @click="handleClick">
      <v-icon v-if="!inProgress">{{activeFab.icon}}</v-icon>
      <v-progress-circular indeterminate v-if="inProgress"></v-progress-circular>
    </v-btn>
    <v-tooltip v-if="progress !== null" top left max-width="300">
      <template v-slot:activator="{ on }">
        <v-btn large fab dark fixed bottom left color="dark" v-on="on">
          <v-progress-circular size="60" :value="progress">{{progress}}</v-progress-circular>
        </v-btn>
      </template>
      Advanced full scan in progress
    </v-tooltip>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-btn flat @click="dialog = false">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SearchStatus",
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    handleClick() {
      if (!this.inProgress) {
        this.$store.dispatch("gateways/scan").then(() => {
          this.$store.dispatch("gateways/scanV2")
        });
      }
    }
  },
  computed: {
    activeFab() {
      if (this.inProgress) {
        return { color: "purple", icon: "loading" };
      }
      return { color: "blue", icon: "search" };
    },
    inProgress() {
      return this.loading || this.full.some(gw => gw.status === "testing");
    },
    ...mapState("gateways", ["loading", "full", "progress"])
  }
};
</script>
<style scoped>
</style>
